import React from "react";
import { required, SimpleForm, TextInput } from "react-admin";

export default ({ mode, ...props }) => (
    <SimpleForm
        {...props}
        redirect="list"
    >
        <TextInput source="KeyCode" validate={[required()]} />
        <TextInput source="KeyValue" validate={[required()]} />
    </SimpleForm>
);
